/**
 * Picks thread id for outbound send; `forceNewThread` always starts a new conversation.
 *
 * @param {{ currentId: string | null, forceNewThread?: boolean, validIds: string[] }} p
 * @returns {{ existingId: string | null, shouldCreate: boolean }}
 */
export function resolveSendThreadId({ currentId, forceNewThread = false, validIds }) {
  const threadId = forceNewThread ? null : currentId
  if (threadId && validIds.includes(threadId)) {
    return { existingId: threadId, shouldCreate: false }
  }
  return { existingId: null, shouldCreate: true }
}
